<div class="filesList" data-cy="files-list">
  @for (file of files(); track $index) {
    <div class="filesList_item" [attr.data-cy]="`file-list-item-${$index}`">
      <div class="filesList_card" [title]="file.name">
        <mat-icon
          svgIcon="close"
          class="filesList_closeBtn"
          title="Delete"
          data-cy="file-list-item-delete-button"
          (click)="onDeleteFile(file)" />

        <app-file-thumbnail [file]="file" />
        <span class="text-small text-truncate">{{ file.name }}</span>
      </div>
    </div>
  }
</div>
